module.exports = __webpack_public_path__ + "img/logo.9210b6eb.jpg";